import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Routes, Route, Navigate } from 'react-router-dom';
import { isAuth } from '../store/actions/users';
import AdminLayout from './components/navigation/AdminLayout';
import Dashboard from './components/dashboard/Dashboard';
import Tenants from './pages/Tenants';
import Users from './pages/Users';
import Logs from './pages/Logs';
import CronJobs from './pages/CronJobs';
import './styles/admin.css';

function AdminGuard({ children }) {
  const { auth, loading, data } = useSelector(state => state.users);

  if (loading || auth === null) {
    return (
      <div className="adm-root adm-loader">
        <span className="adm-spinner" />
      </div>
    );
  }

  if (!auth) return <Navigate to="/account/login" replace />;
  if (data?.role !== 'admin') return <Navigate to="/dashboard" replace />;

  return children;
}

export default function AdminApp() {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(isAuth());
  }, [dispatch]);

  return (
    <div className="adm-root">
      <Routes>
        <Route
          path="/admin"
          element={
            <AdminGuard>
              <AdminLayout />
            </AdminGuard>
          }
        >
          <Route index element={<Dashboard />} />
          <Route path="tenants" element={<Tenants />} />
          <Route path="users" element={<Users />} />
          <Route path="logs" element={<Logs />} />
          <Route path="cron" element={<CronJobs />} />
        </Route>
        <Route path="/admin/*" element={<Navigate to="/admin" replace />} />
      </Routes>
    </div>
  );
}
